import React from 'react'
import PropTypes from 'prop-types'

import styles from './formGroup.module.scss'

const FormGroup = ({ direction, children, style, className }) => {
  return (
    <div className={`${styles[direction]} ${className}`} style={style}>
      {children}
    </div>
  )
}

FormGroup.propTypes = {
  direction: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string
  ]),
  style: PropTypes.bool,
  className: PropTypes.string
}

FormGroup.defaultProps = {
  style: {},
  className: ''
}

export default FormGroup
